import React from 'react';
import { Check, Star, Zap, Crown } from 'lucide-react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
export function PricingSection() {
  const plans = [{
    name: 'Starlet',
    price: '0',
    features: ['Basic Access', 'Limited Games', 'Ads Included', '1 Profile'],
    cta: 'Start Free',
    icon: Star,
    color: 'bg-gray-100',
    textColor: 'text-gray-600',
    borderColor: 'border-gray-200',
    popular: false
  }, {
    name: 'Comet',
    price: '4.99',
    features: ['Full Library', 'Ad-Free', '3 Profiles', 'Sparkle Shield', 'Glow Trail'],
    cta: 'Get Comet',
    icon: Zap,
    color: 'bg-candy-purple/10',
    textColor: 'text-candy-purple',
    borderColor: 'border-candy-purple',
    popular: true
  }, {
    name: 'Nebula',
    price: '9.99',
    features: ['Everything in Comet', 'Pixel Pals', 'Priority Access', 'Family Sharing (5)', 'Bloom Boost Rewards'],
    cta: 'Go Nebula',
    icon: Crown,
    color: 'bg-candy-teal/10',
    textColor: 'text-candy-teal',
    borderColor: 'border-candy-teal',
    popular: false
  }];
  return <section id="pricing" className="py-24 bg-gradient-to-b from-white to-candy-lavender/30" data-id="element-142">
      <div className="container mx-auto px-4 md:px-6" data-id="element-143">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-144">
          <h2 className="text-4xl md:text-5xl font-bold text-candy-dark mb-4" data-id="element-145">
            Pick Your Adventure
          </h2>
          <p className="text-xl text-gray-500" data-id="element-146">
            Choose the plan that fits your family best. Cancel anytime.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start" data-id="element-147">
          {plans.map((plan, index) => <Card key={index} className={`relative p-8 ${plan.popular ? 'scale-105 shadow-2xl z-10 border-4 border-candy-purple' : 'border-2 border-transparent hover:border-candy-lavender'} transition-all duration-300`} hoverEffect={!plan.popular} data-id="element-148">
              {plan.popular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-candy-purple text-white px-4 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-149">
                  Most Popular
                </div>}

              <div className={`w-16 h-16 rounded-2xl ${plan.color} flex items-center justify-center mb-6 mx-auto`} data-id="element-150">
                <plan.icon className={`w-8 h-8 ${plan.textColor}`} data-id="element-151" />
              </div>

              <h3 className="text-2xl font-bold text-center text-gray-800 mb-2" data-id="element-152">
                {plan.name}
              </h3>
              <div className="text-center mb-6" data-id="element-153">
                <span className="text-4xl font-bold text-candy-dark" data-id="element-154">
                  €{plan.price}
                </span>
                <span className="text-gray-500" data-id="element-155">/mo</span>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-156">
                {plan.features.map((feature, i) => <li key={i} className="flex items-center gap-3 text-gray-600" data-id="element-157">
                    <div className={`w-5 h-5 rounded-full ${plan.popular ? 'bg-candy-purple text-white' : 'bg-gray-200 text-gray-500'} flex items-center justify-center text-xs`} data-id="element-158">
                      <Check size={12} strokeWidth={3} data-id="element-159" />
                    </div>
                    {feature}
                  </li>)}
              </ul>

              <Button fullWidth variant={plan.popular ? 'primary' : 'outline'} className={plan.popular ? 'shadow-candy-purple/40' : ''} data-id="element-160">
                {plan.cta}
              </Button>
            </Card>)}
        </div>
      </div>
    </section>;
}